<template>
	<fieldset id="fs-buildingType" class="pt-3 pb-3">
		<div class="container pt-5 pb-2">
			<div class="row no-gutters align-items-center">
				<div class="col-2">
					<div class="field-wrap size-big">
						<label>Weather Station</label>

						<div class="row no-gutters field-icon">
							<select
								v-model="formData.climateZone"
								@change="handleWeatherStationChange"
							>
								<option
									v-for="[station, zone] in weatherStations"
									:key="station"
									:value="zone"
								>
									{{station}}
								</option>
							</select>
						</div>

						<div class="suffix-wrap">
							<p class="desc"></p>
						</div>
					</div>
				</div>

				<div class="col-6 pl-5">
					<div class="field-wrap size-big">
						<p>Please select the nearest weather station to your project site. The data from this station will be used to estimate the annual performance
							of the heat pump model you select.</p>
					</div>
				</div>
			</div>
		</div>
	</fieldset>
</template>

<script>
import jsonFetch from '@/utils/json-fetch'
import formData from '@/components/Sizer/form-data-store'

export default {
	name: 'WeatherStationSelect',

	data: () => ({
		formData,
		weatherStations: [],
	}),

	async created () {
		this.weatherStations = await jsonFetch({
			url: '/sizer/weatherStationsList',
			method: 'GET'
		}).then(({ stations }) => stations)
	},

	methods: {
		handleWeatherStationChange(e) {
			formData.climateZone = e.target.value;
		}
	},
}
</script>
